/* globals */
import ObservabilityProvider from '.'

ObservabilityProvider.setup()
